export default __webpack_public_path__ + "static/media/aboutCore.33b147d5.png";